import { Directive, Injector, OnDestroy, Optional } from '@angular/core';
import {
  provideAsWidgetRef,
  StylableComponent,
  register,
  Parent,
  styler,
  IWidgetConfig
} from "@wm/components-base";
import { remove } from "lodash-es";
import { getClonedObject, runtimeEventManager } from "@wm/core";
import { propFactory as PropertiesFactory } from '@wm/components-base';

const DEFAULT_CLS = 'app-custom-widget app-container';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-custom',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmCustom]',
  providers: [
    provideAsWidgetRef(CustomComponent)
  ],
  standalone: true,
  exportAs: 'wmCustom'
})
export class CustomComponent extends StylableComponent implements OnDestroy {
  static initializeProps = register('wm-custom');
  defaultClass = DEFAULT_CLS;
  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    this.loadProperties(this, this.$attrs);
  }
  override ngOnDestroy() {
    this.removeProperties(this)
  }

  removeProperties(widget: any) {
    widget.customProps && widget.customProps.forEach( (p: any)=> {
      remove(widget.groupToAdd.properties, (propertyName) => {
        return propertyName === p.name;
      });
    });
  }

  loadProperties(el: any, attrs?: any) {
    this.removeProperties(this);
    el.widgetProps = getClonedObject(this.widgetProps);
    el.customProps = [];
    el.groupToAdd = PropertiesFactory.getPropertyGroups()
      .filter((o: any) => { return o.name === 'properties'; })[0].subGroups
      .filter((n: any) => { return !n.name; })[0];
    if(attrs) {
      [ ...attrs.keys() ].forEach((k: string) => {
        if (k.endsWith('param')||k.endsWith('param.bind')) {
          el.customProps.push({
            name: k.replace(/.bind$/,''),
            label: k.replace(/param(\.bind)?$/,''),
            value: attrs.get(k),
            type: 'string',
            show: true,
            bindable: 'in-out-bound'
          });
        }
      });
    }
    remove(el.groupToAdd.properties,  (s)=> { return s === 'addproperty'; });
    el.customProps.forEach( (p: any) =>{
      el.widgetProps[p.name] = p;
      if (!el.groupToAdd.properties.includes(p.name)) {
        el.groupToAdd.properties.push(p.name);
      }
    });
    el.groupToAdd.properties.push('addproperty');
    if(!(el?.viewParent && el.viewParent?.prefabName))
    {
      runtimeEventManager.emit('initPropertyGroups');
    }

  }
}
